export const getQueryTransportKeys = {
  transportDocs: (transportId) => ['transportDocs', transportId],
};
